import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import About from './component/About';
import Contact from './component/Contact';
import Blog from './component/Blog';
import Navbar from './component/Navbar';
import Home from './component/Home';
import Footer from './component/Footer';

function App() {
  return (
    <Router>
        <Navbar />
        <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog/>} />
        </Routes>
        <Footer/>
    </Router>
  );
}

export default App;
